import { render } from "./UsoTest.vue?vue&type=template&id=577a09a4&scoped=true"
import script from "./UsoTest.vue?vue&type=script&lang=js"
export * from "./UsoTest.vue?vue&type=script&lang=js"

import "./UsoTest.vue?vue&type=style&index=0&id=577a09a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577a09a4"]])

export default __exports__